import { UserId } from '@cibo/core'
import { SubmitButton, useFormFactor } from '@cibo/ui'
import { Box, Button, InputLabel, Stack, Typography } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-mui'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { AUTH_ROUTES } from '../../pages/consts'

export type EmulationUserQuery = {
  username?: string
  userId?: UserId
}

type EmulateUserFormDisplayProps = {
  isLoading?: boolean
  onSubmit(values: EmulationUserQuery): void
  onCancel?(): void
  onSuccess?(): void
}

const EmulateUserForm = ({
  isLoading,
  onSubmit,
  onCancel,
  onSuccess,
}: EmulateUserFormDisplayProps) => {
  const { t } = useTranslation('auth')
  const { isMobile } = useFormFactor()

  return (
    <>
      <Typography variant="h5">{t('emulateUser')}</Typography>

      <Stack direction={isMobile ? 'column' : 'row-reverse'} spacing={2}>
        <Box style={isMobile ? {} : { flex: 1 }}>
          <Formik
            onSubmit={values => onSubmit(values)}
            initialValues={{
              username: '',
            }}
          >
            {form => {
              return (
                <Form>
                  <Stack spacing={2}>
                    <Stack>
                      <InputLabel shrink htmlFor="email">
                        {t('email')}
                      </InputLabel>
                      <Field
                        autoFocus
                        id="username"
                        type="text"
                        name="username"
                        component={TextField}
                        disabled={isLoading}
                      />
                    </Stack>

                    <Stack>
                      <InputLabel shrink htmlFor="userId">
                        {t('userId')}
                      </InputLabel>
                      <Field
                        id="userId"
                        name="userId"
                        component={TextField}
                        type="number"
                        disabled={isLoading}
                      />
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Button component={NavLink} to={AUTH_ROUTES.LOGIN}>
                        {t('backToLogin')}
                      </Button>
                      <SubmitButton loading={isLoading} disabled={isLoading} type="submit">
                        {t('emulate')}
                      </SubmitButton>
                    </Stack>
                  </Stack>
                </Form>
              )
            }}
          </Formik>
        </Box>
      </Stack>
    </>
  )
}

export default EmulateUserForm
